import { Routes, Route, Navigate } from 'react-router-dom';

import ProductListingsContainer from './product-listings/MarketProductListings.container';
import BookmarkedListingsContainer from './bookmarked-listings/BookmarkedListings.container';
import BuyerListingsContainer from './buyer-listings/MarketBuyerListings.container';
import FeaturedListingsContainer from './featured-listings/FeaturedListings.container';
import MarketBuzzContainer from './market-buzz/MarketBuzz.container';
import MarketBuzzCreatePostContainer from './market-buzz/market-buzz-create-post/MarketBuzzCreatePost.container';
import DirectMessagesContainer from './direct-messages/DirectMessages.container';
import ProductListingPageContainer from './product-listing-page/ProductListingPage.container';
import BuyerListingPageContainer from './buyer-listing-page/BuyerListingPage.container';

const MarketContainer = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/market/product-listings" />} />
      <Route path="/product-listings" element={<ProductListingsContainer />} />
      <Route path="/bookmarked-listings" element={<BookmarkedListingsContainer />} />
      <Route path="/buyer-listings" element={<BuyerListingsContainer />} />
      <Route path="/featured-listings" element={<FeaturedListingsContainer />} />
      <Route path="/market-buzz" element={<MarketBuzzContainer />} />
      <Route path="/market-buzz/create" element={<MarketBuzzCreatePostContainer />} />
      <Route path="/market-buzz/edit/" element={<MarketBuzzCreatePostContainer />} />
      <Route path="/direct-messages" element={<DirectMessagesContainer />} />
      <Route path="/direct-messages/:activeChatExternalReference" element={<DirectMessagesContainer />} />
      <Route path="/product-listing/:productExternalReference" element={<ProductListingPageContainer />} />
      <Route path="/buyer-listing/:productExternalReference" element={<BuyerListingPageContainer />} />
    </Routes>
  );
};

export default MarketContainer;
